module.exports = __webpack_public_path__ + "static/tools-resources-t-shirt-photo-4c9a0923071a9c2a74e5f4fbd3c45583.jpg";